// Root Component
import React from "react";

export function PaymentRoot({ children }) {
    return (
        <div className="payment-status-popup">
            <div className="payment-status-popup__overlay" />
            <div className="payment-status-popup__content">{children}</div>
        </div>
    );
}

// Title Component with Dynamic Styling
export function PaymentTitle({ title, variant }) {
    const titleClass =
        variant === "success"
            ? "payment-status-popup__title payment-status-popup__title--success"
            : "payment-status-popup__title payment-status-popup__title--failed";

    return <h3 className={titleClass}>{title}</h3>;
}

// Icon Component
export function PaymentIcon({ icon, alt }) {
    return (
        <div className="payment-status-popup__icon">
            <img src={icon} alt={alt} />
        </div>
    );
}

// Message Component
export function PaymentMessage({ message }) {
    return <p className="payment-status-popup__message">{message}</p>;
}

// Actions Wrapper
export function PaymentActions({ children }) {
    return <div className="payment-status-popup__actions">{children}</div>;
}

// Button Component
export function PaymentButton({ label, onClick, isLoading, textWhileLoading,variant = "primary" }) {
    const buttonClass =
        variant === "primary"
            ? "payment-status-popup__button payment-status-popup__button--primary"
            : "payment-status-popup__button payment-status-popup__button--secondary";

    return (
        <button className={buttonClass} onClick={onClick} disabled={isLoading}>
            {isLoading ? <><i className="fa fa-spinner fa-spin"/>&nbsp;&nbsp; <span>{textWhileLoading}</span></> : label}
        </button>
    );
}
